import { render, staticRenderFns } from "./ProductSpecificationsComponent.vue?vue&type=template&id=664404c5&scoped=true&"
import script from "./ProductSpecificationsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecificationsComponent.vue?vue&type=style&index=0&id=664404c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664404c5",
  null
  
)

export default component.exports